(function () {
  const GRAPHQL = 'https://api.whatnot.com/graphql/';
  const HEADERS = {
    'Content-Type': 'application/json',
    Origin: 'https://www.whatnot.com',
    Referer: 'https://www.whatnot.com/',
    'Apollographql-Client-Name': 'web',
    'X-Whatnot-App': 'whatnot-web',
  };

  const GET_USER_LIVE = `
    query PokespottGetUserLive($username: String) {
      getUser(username: $username) {
        id
        username
        isLive
        livestreams(first: 10) {
          edges {
            node {
              id
              status
              title
            }
          }
        }
      }
    }
  `;

  async function graphql(query, variables) {
    const response = await fetch(GRAPHQL, {
      method: 'POST',
      headers: HEADERS,
      body: JSON.stringify({ query, variables }),
      credentials: 'omit',
    });

    if (!response.ok) {
      throw new Error('Whatnot API HTTP ' + response.status);
    }

    const payload = await response.json();
    if (payload.errors?.length) {
      throw new Error(payload.errors[0].message || 'Whatnot API error');
    }

    return payload.data;
  }

  function decodeLiveId(encodedId) {
    try {
      const decoded = atob(encodedId);
      const match = decoded.match(/:(\d+)$/);
      return match ? match[1] : encodedId;
    } catch {
      return encodedId;
    }
  }

  function buildLiveUrl(id, shareUrl) {
    if (!id) return shareUrl;
    if (/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(id)) {
      return 'https://www.whatnot.com/live/' + id;
    }
    return 'https://www.whatnot.com/live/' + decodeLiveId(id);
  }

  function parseUserLiveStatus(user, shareUrl) {
    if (!user) return { live: false };

    const nodes = (user.livestreams?.edges || [])
      .map(function (edge) {
        return edge?.node;
      })
      .filter(Boolean);

    const playing = nodes.find(function (node) {
      return node.status === 'PLAYING' || node.status === 'LIVE';
    });

    if (!user.isLive && !playing) {
      return { live: false };
    }

    const stream = playing || nodes[0];
    return {
      live: true,
      title: stream?.title,
      liveUrl: buildLiveUrl(stream?.id, shareUrl),
    };
  }

  async function fetchLiveStatus(config) {
    let graphqlStatus = null;

    try {
      const data = await graphql(GET_USER_LIVE, { username: config.username });
      graphqlStatus = parseUserLiveStatus(data?.getUser, config.shareUrl);
      if (graphqlStatus.live) {
        return graphqlStatus;
      }
    } catch {
      // GraphQL indisponible — repli proxy ou share link ci-dessous.
    }

    if (config.proxyUrl) {
      const proxy = new URL(config.proxyUrl);
      proxy.searchParams.set('username', config.username);
      proxy.searchParams.set('shareUrl', config.shareUrl);
      const response = await fetch(proxy.toString(), { credentials: 'omit' });
      if (!response.ok) throw new Error('Proxy HTTP ' + response.status);
      const proxyStatus = await response.json();
      if (graphqlStatus && !graphqlStatus.live) {
        return { live: false };
      }
      return proxyStatus;
    }

    return graphqlStatus || { live: false };
  }

  function applyDiscordCardState(root, state, config) {
    const card = root.querySelector('.pokespott-discord__whatnot-card');
    const badge = root.querySelector('[data-whatnot-live-badge]');
    const cta = root.querySelector('[data-whatnot-cta]');
    const ctaLabel = root.querySelector('[data-whatnot-cta-label]');
    const status = root.querySelector('[data-whatnot-status]');

    if (!card) return;

    card.classList.remove('is-live', 'is-checking');

    if (state.live) {
      card.classList.add('is-live');
      if (badge) badge.hidden = false;
      if (status) status.textContent = state.title || config.textLiveStatus || 'Live en cours';
      if (cta) cta.href = state.liveUrl || config.shareUrl;
      if (ctaLabel) ctaLabel.textContent = config.textLiveCta || 'Rejoindre le live';
      return;
    }

    if (badge) badge.hidden = true;
    if (status) status.textContent = config.textIdleStatus || 'Hors live — profil actif';
    if (cta) cta.href = config.shareUrl;
    if (ctaLabel) ctaLabel.textContent = config.textIdleCta || 'Voir le profil Whatnot';
  }

  function applyState(root, state, config) {
    const banner = root.querySelector('.poke-live-banner');
    const cta = root.querySelector('.poke-live-banner__cta');
    const pulse = root.querySelector('.poke-live-banner__pulse');
    const title = root.querySelector('.poke-live-banner__title');
    const eyebrow = root.querySelector('.poke-live-banner__eyebrow');
    const ctaLabel = root.querySelector('.poke-live-banner__cta-label');

    if (!banner) return;

    banner.classList.remove('is-live', 'is-idle', 'is-checking');

    if (state.live) {
      banner.classList.add('is-live');
      root.hidden = false;
      if (pulse) pulse.hidden = false;
      if (eyebrow) eyebrow.textContent = config.textLiveEyebrow || 'En direct';
      if (title && state.title) title.textContent = state.title;
      if (cta) cta.href = state.liveUrl || config.shareUrl;
      if (ctaLabel) ctaLabel.textContent = config.textLiveCta || 'Rejoindre le live';
      return;
    }

    banner.classList.add('is-idle');
    if (config.hideWhenOffline) {
      root.hidden = true;
      return;
    }

    root.hidden = false;
    if (pulse) pulse.hidden = true;
    if (eyebrow) eyebrow.textContent = config.textIdleEyebrow || 'Whatnot';
    if (title) title.textContent = config.textIdleTitle || 'Nos lives Whatnot';
    if (cta) cta.href = config.shareUrl;
    if (ctaLabel) ctaLabel.textContent = config.textIdleCta || 'Voir le profil';
  }

  function initRoot(root) {
    const isDiscordCard = root.dataset.whatnotVariant === 'discord-card';

    const config = {
      username: root.dataset.whatnotUsername || 'poke_spott',
      shareUrl: root.dataset.whatnotShareUrl || 'https://www.whatnot.com/s/3oKA3efE',
      liveShareUrl: root.dataset.whatnotLiveShareUrl || '',
      proxyUrl: root.dataset.whatnotProxyUrl || '',
      hideWhenOffline: root.dataset.hideWhenOffline === 'true',
      forceOffline: root.dataset.forceOffline === 'true',
      manualLive: root.dataset.manualLive === 'true',
      autoDetect: root.dataset.autoDetect !== 'false',
      pollMs: Number(root.dataset.pollMs || 60000) || 60000,
      textLiveEyebrow: root.dataset.textLiveEyebrow,
      textIdleEyebrow: root.dataset.textIdleEyebrow,
      textIdleTitle: root.dataset.textIdleTitle,
      textLiveCta: root.dataset.textLiveCta,
      textIdleCta: root.dataset.textIdleCta,
      textLiveStatus: root.dataset.textLiveStatus,
      textIdleStatus: root.dataset.textIdleStatus,
    };

    const apply = isDiscordCard ? applyDiscordCardState : applyState;

    if (config.forceOffline) {
      apply(root, { live: false }, config);
      return;
    }

    function applyManualLive() {
      apply(
        root,
        {
          live: true,
          liveUrl: root.dataset.manualLiveUrl || config.shareUrl,
          title: root.dataset.manualLiveTitle || '',
        },
        config
      );
    }

    if (config.manualLive && !config.autoDetect) {
      applyManualLive();
      return;
    }

    if (config.manualLive) {
      applyManualLive();
      return;
    }

    if (!config.autoDetect) {
      apply(root, { live: false }, config);
      return;
    } else if (!isDiscordCard) {
      const banner = root.querySelector('.poke-live-banner');
      if (banner) banner.classList.add('is-checking');
    } else {
      root.querySelector('.pokespott-discord__whatnot-card')?.classList.add('is-checking');
    }

    async function refresh() {
      try {
        const status = await fetchLiveStatus(config);
        apply(root, status, config);
      } catch {
        if (config.manualLive && !config.autoDetect) {
          applyManualLive();
        } else {
          apply(root, { live: false }, config);
        }
      } finally {
        root.querySelector('.pokespott-discord__whatnot-card')?.classList.remove('is-checking');
      }
    }

    refresh();
    if (config.pollMs > 0) {
      window.setInterval(refresh, config.pollMs);
    }
  }

  function init() {
    document.querySelectorAll('[data-pokespott-whatnot-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
